export const sources={};export const img={src:"__VITE_ASSET__y3WuTrdTs_Si7uYpRddj9w__",w:640,h:640};export default{sources:sources,img:img};